import * as React from 'react'
import { FC } from 'react'

import { EditAdditionalInfoFormWrapper } from './EditFormWrapper'
import { ENTITY_TYPES } from '@sales-center/common'
import { SideDrawer } from '@sales-center/components'

interface Props {
  entityId: number
  entityType: ENTITY_TYPES
  onClose: () => void
  open: boolean
}

export const EditAdditionalInfoDrawer: FC<Props> = (props) => {
  const { entityId, entityType, onClose, open } = props

  return (
    <SideDrawer
      title={`Edit Additional Information`}
      onClose={onClose}
      open={open}
      width={550}
    >
      <EditAdditionalInfoFormWrapper
        entityId={entityId}
        entityType={entityType}
        onClose={onClose}
      />
    </SideDrawer>
  )
}

EditAdditionalInfoDrawer.displayName = 'EditAdditionalInfoDrawer'
